import React, { PureComponent } from 'react';
import classnames from 'classnames';

import { HEADING_PROP_TYPES } from '../constants/componentPropTypes';
import Image from './Image';

export default class Heading extends PureComponent {
    static propTypes = HEADING_PROP_TYPES;

    static defaultProps = {
        useSmallFont: false,
        alignCenter: false,
        removeVerticalPadding: false,
        removeHorizontalPadding: false,
        textColor: 'grey-600',
        headingColor: 'grey-900',
    };

    render() {
        const {
            heading,
            secondaryHeading,
            description,
            imagePath,
            pageName,
            useSmallFont,
            alignCenter,
            additionalPadding,
            removeVerticalPadding,
            removeHorizontalPadding,
            bgColor,
            headingColor,
            textColor,
            useSmallerMessaging,
        } = this.props;

        if (!heading) {
            return null;
        }

        let secondaryHeadingContent = null;
        const secondaryHeadingClassName = `eds-text-color--${textColor} marketing-default-text eds-text-bl`;

        if (secondaryHeading) {
            // dangerously set HTML because of links in secondary heading in overview page
            const messageHtml = {
                __html: secondaryHeading.toString(),
            };

            secondaryHeadingContent = (
                <h2
                    className={`${secondaryHeadingClassName} secondary-heading--link`}
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={messageHtml}
                />
            );
        }

        const descriptionContent = description && (
            <p
                className={`eds-text-color--${textColor} marketing-default-text eds-text-bl`}
            >
                {description}
            </p>
        );
        const headingContainerClassName = classnames(
            `eds-bg-color--${bgColor}`,
            {
                'eds-l-pad-top-6 eds-l-pad-bot-12': additionalPadding,
            },
        );
        const largeScreenClassName = classnames(
            'eds-show-up-sw eds-text--center eds-g-cell',
            {
                'eds-l-pad-top-12 eds-l-pad-bot-8': !removeVerticalPadding,
                'eds-l-pad-hor-12': !removeHorizontalPadding,
                'eds-g-offset-1-12 eds-g-cell-10-12': !useSmallerMessaging,
                'eds-g-offset-2-12 eds-g-cell-8-12 eds-l-pad-vert-16': useSmallerMessaging,
            },
        );
        const headingClassName = classnames(`eds-text-color--${headingColor}`, {
            'eds-l-pad-vert-4': !removeVerticalPadding,
            'eds-l-mar-bot-4': removeVerticalPadding,
            'eds-text-hm': !useSmallFont,
            'eds-text-hs': useSmallFont,
            'eds-text-weight--regular': useSmallerMessaging,
        });
        const smallScreenClassName = classnames(
            'eds-show-down-sm eds-l-pad-all-6',
            {
                'eds-text--center': alignCenter,
            },
        );
        let imageSection = null;

        if (imagePath) {
            imageSection = <Image pageName={pageName} imagePath={imagePath} />;
        }

        return (
            <div className={headingContainerClassName}>
                <section className={largeScreenClassName}>
                    <h1 className={headingClassName}>{heading}</h1>
                    {secondaryHeadingContent}
                    {descriptionContent}
                </section>
                <section className={smallScreenClassName}>
                    <h1 className={headingClassName}>{heading}</h1>
                    {secondaryHeadingContent}
                    {descriptionContent}
                </section>
                {imageSection}
            </div>
        );
    }
}
